import { render, staticRenderFns } from "./ManageOrderFiltersModal.vue?vue&type=template&id=1634c75e"
import script from "./ManageOrderFiltersModal.vue?vue&type=script&lang=ts"
export * from "./ManageOrderFiltersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports